<template>
  <div class='mt-1'>
    <b-modal
      ref='import-lists'
      id='import-lists'
      hide-footer
      header-bg-variant='info'
      header-text-variant='light'
      hide-header
      size='lg'
      @show='showModal()'
    >
      <section class="modal-font-family">
        <section class='d-flex align-content-center justify-content-between '>
          <section>
            <p class='title mt-1 mb-0'>
              Importar listas
            </p>
          </section>

          <section>
            <b-icon
              style='cursor: pointer'
              @click='closeModal()'
              class='ml-1'
              font-scale='2.5'
              icon='x'
              color='#262626'
            >
            </b-icon>
          </section>
        </section>

        <section class="my-3">
          <label for="import-type">Forma de importação</label>
          <b-form-select
            id="import-type"
            v-model="importType"
            :options="importTypes"
            style="height: 36px"
            value-field="key"
            text-field="value"
            @change="onChangeImportType"
          ></b-form-select>
        </section>

        <section class="my-3" v-if="importType === 'file'">
          <a
            href="https://files-hofacil.s3.amazonaws.com/1781284892557"
            target="_blank"
            class="download-link d-flex align-items-center"
          >
            <b-icon icon="download" font-scale="1.2" class="mr-1"></b-icon>
            <span>Baixar modelo de planilha</span>
          </a>
          <b-alert show variant="warning" class="d-flex align-items-center mb-0 mt-2">
            Caso o arquivo contenha mais de uma aba, somente a primeira será processada. As demais serão desconsideradas.
          </b-alert>
        </section>

        <section class="my-3" v-if="importType === 'link'">
          <a
            href="https://files-hofacil.s3.amazonaws.com/1786588984630"
            target="_blank"
            class="download-link d-flex align-items-center"
          >
            <b-icon icon="download" font-scale="1.2" class="mr-1"></b-icon>
            <span>Baixar modelo de planilha</span>
          </a>
          <b-alert show variant="warning" class="d-flex align-items-center mb-0 mt-2">
            A planilha precisa estar compartilhada com a conta de serviço do sistema e conter as colunas do formulário de
            cadastro. Somente a primeira aba será processada e os novos registros serão liberados automaticamente.
          </b-alert>
        </section>

        <section class="d-flex flex-column align-items-start my-4">
          <section class='w-100 mb-3' v-if="importType === 'link'">
            <label for="spreadsheet-url">Link da planilha do Google</label>
            <b-form-input
              id="spreadsheet-url"
              v-model="spreadsheetUrl"
              style="height: 36px"
              placeholder="https://docs.google.com/spreadsheets/d/..."
              required
            ></b-form-input>
          </section>

          <section class='w-100 mb-3' v-if="importType === 'file'">
            <label>Arquivo em excel</label>
            <input accept=".xlsx" type='file' id='files' @change='onChange' hidden />
            <label class='label-file d-flex align-items-center px-2' for='files'>
              <strong class='ml-3' v-if='file && file.name'>{{ file.name }}</strong>

              <svg v-if='!file || !file.name' width="14" height="18" viewBox="0 0 14 18" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.0026 0.666748V6.08341C7.00262 6.39415 7.11837 6.69374 7.32729 6.92376C7.5362 7.15379 7.8233 7.29775 8.1326 7.32758L8.2526 7.33341H13.6693V15.6667C13.6694 16.0872 13.5106 16.4922 13.2247 16.8005C12.9388 17.1089 12.5469 17.2977 12.1276 17.3292L12.0026 17.3334H2.0026C1.58212 17.3335 1.17713 17.1747 0.868814 16.8888C0.560496 16.6029 0.37164 16.211 0.340104 15.7917L0.335938 15.6667V2.33341C0.335805 1.91293 0.49461 1.50794 0.780518 1.19962C1.06643 0.891307 1.45831 0.702451 1.8776 0.670915L2.0026 0.666748H7.0026ZM7.0026 8.58341C6.79849 8.58344 6.60149 8.65838 6.44896 8.79401C6.29643 8.92964 6.19899 9.11654 6.1751 9.31925L6.16927 9.41675V10.6667H4.91927C4.70687 10.667 4.50258 10.7483 4.34813 10.8941C4.19368 11.0399 4.10074 11.2392 4.08829 11.4512C4.07585 11.6633 4.14483 11.8721 4.28116 12.0349C4.41748 12.1978 4.61086 12.3025 4.82177 12.3276L4.91927 12.3334H6.16927V13.5834C6.16951 13.7958 6.25084 14.0001 6.39664 14.1546C6.54245 14.309 6.74173 14.4019 6.95377 14.4144C7.1658 14.4268 7.37459 14.3579 7.53746 14.2215C7.70034 14.0852 7.80502 13.8918 7.8301 13.6809L7.83594 13.5834V12.3334H9.08594C9.29834 12.3332 9.50263 12.2518 9.65708 12.106C9.81152 11.9602 9.90447 11.761 9.91691 11.5489C9.92936 11.3369 9.86038 11.1281 9.72405 10.9652C9.58772 10.8023 9.39435 10.6977 9.18344 10.6726L9.08594 10.6667H7.83594V9.41675C7.83594 9.19573 7.74814 8.98377 7.59186 8.82749C7.43558 8.67121 7.22362 8.58341 7.0026 8.58341ZM8.66927 0.702581C8.93875 0.759789 9.18985 0.882905 9.4001 1.06091L9.5026 1.15508L13.1809 4.83341C13.3762 5.02851 13.5199 5.26904 13.5993 5.53341L13.6326 5.66675H8.66927V0.702581Z"
                      fill="#022245" />
              </svg>

              <span class="ml-2" v-if='!file || !file.name'>Anexar lista de e-mails</span>
            </label>
          </section>

          <section class='w-100 mb-3' v-if="importType === 'link'">
            <label for="expiration-type">Forma de vencimento do plano</label>
            <b-form-select
              id="expiration-type"
              v-model="expirationType"
              :options="expirationTypes"
              style="height: 36px"
              value-field="key"
              text-field="value"
            ></b-form-select>
          </section>

          <section class='w-100' v-if="importType === 'file' || expirationType === 'date'">
            <label>Data de vencimento do plano</label>
            <b-form-input
              v-model="accessExpirationDate"
              type="date"
              style="height: 36px"
              placeholder="Enter email"
              required
            ></b-form-input>
          </section>

          <section class='w-100' v-if="importType === 'link' && expirationType === 'months'">
            <label for="expiration-months">Quantidade de meses do vencimento</label>
            <b-form-select
              id="expiration-months"
              v-model="expirationMonths"
              :options="expirationMonthsOptions"
              style="height: 36px"
            ></b-form-select>
          </section>
        </section>

        <section class='mt-4'>
          <b-alert show variant='danger' :class='{ hidden: !error }'>
            {{ error }}<br />
          </b-alert>
        </section>

        <section>
          <b-overlay
            :show='loading'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='d-inline-block w-100'
          >
            <button
              @click="save()"
              class='btn-add w-100 p-2'
            >
              <span>Importar</span>
            </button>
          </b-overlay>
        </section>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import XLSX from 'xlsx'
import { decrypt } from '@/utils/EncryptDecryptData'

export default {
  name: 'ImportLists',
  components: {},
  props: {},
  data() {
    return {
      accessExpirationDate: null,
      loading: false,
      file: null,
      emails: [],
      importType: 'file',
      spreadsheetUrl: null,
      expirationType: 'date',
      expirationMonths: null,
      importTypes: [
        { key: 'file', value: 'Importar planilha' },
        { key: 'link', value: 'Informar link da planilha' }
      ],
      expirationTypes: [
        { key: 'date', value: 'Informar data de vencimento' },
        { key: 'months', value: 'Definir quantidade de meses' }
      ],
      expirationMonthsOptions: [
        { value: null, text: 'Selecione a quantidade de meses', disabled: true },
        ...Array.from({ length: 12 }, (_, index) => ({
          value: index + 1,
          text: `${index + 1} ${index + 1 === 1 ? 'mês' : 'meses'}`
        }))
      ]
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    error() {
      return this.$store.getters['access/error']
    }
  },
  methods: {
    ...mapActions('importEmailsPlanRelease', {
      handleCreate: 'handleCreate'
    }),
    async showModal() {
      this.accessExpirationDate = null
      this.loading = false
      this.file = null
      this.emails = []
      this.importType = 'file'
      this.spreadsheetUrl = null
      this.expirationType = 'date'
      this.expirationMonths = null
      await this.$store.dispatch('access/updateError', '')
    },
    async onChangeImportType() {
      this.file = null
      this.emails = []
      this.spreadsheetUrl = null
      this.expirationType = 'date'
      this.expirationMonths = null
      await this.$store.dispatch('access/updateError', '')
    },
    getSpreadsheetId() {
      const [, spreadsheetId] = String(this.spreadsheetUrl || '').match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/) || []
      return spreadsheetId || null
    },
    async buildSpreadsheetLinkBody() {
      if (!this.getSpreadsheetId()) {
        await this.$store.dispatch('access/updateError', 'Informe um link válido de uma planilha do Google!')
        return null
      }

      if (this.expirationType === 'months') {
        if (!this.expirationMonths) {
          await this.$store.dispatch('access/updateError', 'Selecione a quantidade de meses de vencimento do plano!')
          return null
        }
        return {
          importType: 'link',
          spreadsheetUrl: this.spreadsheetUrl,
          expirationType: 'months',
          expirationMonths: this.expirationMonths,
          userImportedListId: this.user.id
        }
      }

      if (!this.accessExpirationDate) {
        await this.$store.dispatch('access/updateError', 'Informe a data de vencimento do acesso!')
        return null
      }
      return {
        importType: 'link',
        spreadsheetUrl: this.spreadsheetUrl,
        expirationType: 'date',
        accessExpirationDate: this.accessExpirationDate,
        userImportedListId: this.user.id
      }
    },
    async buildFileBody() {
      if (!this.file || !this.file.name) {
        await this.$store.dispatch('access/updateError', 'É obrigatório anexar lista de e-mails!')
        return null
      }

      if(!this.emails || this.emails.length === 0) {
        await this.$store.dispatch('access/updateError', 'Arquivo sem registros para fazer importação')
        return null
      }
      for (const email of this.emails) {
        if (!email['E-mail do cliente']) {
          await this.$store.dispatch('access/updateError', 'Por favor, verifique o arquivo, o campo ‘E-mail do cliente’ não está presente!')
          return null
        }
        if (!email['Nome do cliente']) {
          await this.$store.dispatch('access/updateError', 'Por favor, verifique o arquivo, o campo ‘Nome do cliente’ não está presente!')
          return null
        }
        if (!email['Telefone do cliente']) {
          await this.$store.dispatch('access/updateError', 'Por favor, verifique o arquivo, o campo ‘Telefone do cliente’ não está presente!')
          return null
        }
      }
      return {
        importType: 'file',
        accessExpirationDate: this.accessExpirationDate,
        fileName: this.file.name,
        userImportedListId: this.user.id,
        emails: this.emails
      }
    },
    async save() {
      try {
        await this.$store.dispatch('access/updateError', '')

        const usesMonthsExpiration = this.importType === 'link' && this.expirationType === 'months'
        if (!usesMonthsExpiration && !this.accessExpirationDate) {
          await this.$store.dispatch('access/updateError', 'Informe a data de vencimento do acesso!')
          return
        }

        const body = this.importType === 'link'
          ? await this.buildSpreadsheetLinkBody()
          : await this.buildFileBody()

        if (!body) {
          return
        }

        this.loading = true
        const { status, data } = await this.handleCreate(body)

        let message = data.message
        let variant = 'danger'
        if(status === 201){
          message = data.message;
          variant = 'success';
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000,
        });
        this.loading = false
        this.closeModal()
        this.$emit('reload')
      } catch (e) {
        const rawData = e && e.response && e.response.data
        const errorData = typeof rawData === 'string' ? decrypt(rawData) : rawData
        const message = (errorData && errorData.message) || 'Ocorreu um erro inesperado. Tente novamente.'
        await this.$store.dispatch('access/updateError', message)
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
      }
    },

    async onChange(event) {
      const [file] = Array.from(event.target.files)
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
      ]
      if (!validTypes.includes(file.type)) {
        await this.$store.dispatch('access/updateError', 'Arquivo inválido. Envie um arquivo Excel (.xlsx).')
        this.file = {}
        this.emails = []
        return
      }
      this.file = file
      const fileReader = new FileReader()
      fileReader.onload = async (event) => {
        const data = event.target.result
        const workbook = XLSX.read(data, { type: 'binary' })

        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
          await this.$store.dispatch('access/updateError', 'A planilha não contém nenhuma aba.')
          this.file = {}
          this.emails = []
          return
        }

        const firstSheetName = workbook.SheetNames[0]
        const firstSheet = workbook.Sheets[firstSheetName]

        if (!firstSheet) {
          await this.$store.dispatch('access/updateError', `Não foi possível ler a aba "${firstSheetName}".`)
          this.file = {}
          this.emails = []
          return
        }

        const rows = XLSX.utils.sheet_to_json(firstSheet)

        if (!rows || rows.length === 0) {
          await this.$store.dispatch('access/updateError', 'A planilha está vazia.')
          this.file = {}
          this.emails = []
          return
        }

        this.emails = rows.map(row => Object.fromEntries(Object.entries(row).map(([key, value]) => [key.trim(), value])))
      }
      await fileReader.readAsBinaryString(this.file)
    },

    closeModal() {
      this.$bvModal.hide('import-lists')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.title {
  font-weight: 700;
  font-size: 20px;
  color: #262626;
}

label {
  font-weight: 600;
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.label-file {
  border: 1px solid #AEBBCD;
  border-radius: 5px;
  background: #FFFFFF;
  font-weight: 400;
  font-size: 14px;
  color: #6D7989;
  height: 36px;
}

.download-link {
  font-size: 15px;
  font-weight: 600;
  color: var(--navy-blue);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}


</style>
